export enum RuntimeRuleEnum {
  NA,
  'First Run'
}

export namespace RuntimeRuleEnum {
  export function values() {
    return Object.keys(RuntimeRuleEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
